import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5cb3116f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['item-card', { 'cursor-pointer': _ctx.clickable }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.formatItemTypeTitle()), 1),
    _createVNode(_component_v_icon, {
      class: "item-icon",
      icon: _ctx.iconName
    }, null, 8, ["icon"]),
    _createVNode(_component_v_icon, {
      class: _normalizeClass(["item-icon", { 'cursor-move': _ctx.draggable }]),
      icon: "mdi-drag-vertical",
      size: "small"
    }, null, 8, ["class"])
  ], 2))
}